var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.imagesUrl),function(imageUrl,index){return _c('v-img',{key:index,attrs:{"img-url":imageUrl,"height":_vm.size.height,"width":_vm.size.width,"src":imageUrl}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }